// Minimal, modern single-line console warning for developers
console.log(
  "%cDisocy | %cHey, developer!%c This area is for development and debugging only. Do NOT copy or paste anything here unless you know what you're doing. Proceed with caution. - Disocy Team",
  "color: #f0ebd8; background: #1a1917; font-size: 20px; font-weight: bold; padding: 6px 12px; border-radius: 8px 0 0 8px;",
  "color: #1a1917; background: #f0ebd8; font-size: 16px; font-weight: bold; padding: 6px 12px;",
  "color: #1a1917; background: #f0ebd8; font-size: 16px; font-weight: normal; padding: 6px 12px; border-radius: 0 8px 8px 0;"
);
